<template>
    <div v-if="selectionObjects.length === 0" class="px-2 text-base">
        {{ placeholder }}
    </div>
    <div v-else class="flex flex-wrap items-center gap-2 p-2">
        <div
            v-for="selection in selectionObjects"
            :key="selection.id"
            class="inline-flex min-w-0 flex-shrink items-center justify-between rounded-sm bg-gray-light p-1 px-3"
        >
            <span class="min-w-0 flex-1 truncate pr-2 text-sm font-normal text-gray-text">{{ selection.displayName }}</span>
            <span v-if="selection.countDisplay" class="flex-shrink-0 rounded-lg bg-gray-lightest px-1 py-0.5 text-[10px] font-medium text-gray-500">{{
                selection.countDisplay
            }}</span>
        </div>
    </div>
</template>

<script setup>
// Props
const props = defineProps({
    selectionObjects: {
        type: Array,
        required: true,
        default: () => [],
    },
    placeholder: {
        type: String,
    },
});
</script>
